<template>
    <el-form ref="form" :model="form" label-width="10%; "  >

        <!--<el-button type="success" size="small" icon="el-icon-plus"-->
                   <!--@click.stop="addPrice">新增报价单-->
        <!--</el-button>-->

        <el-table
                :data="form.tableData"
                style="width: 100%; margin-left: 10px; margin-right: 10px;">

            <el-table-column label="">
                <template slot-scope="scope">

                    <el-row :gutter="24">
                        <el-col :span="1">
                            <div align="left">
                                <img width="30px" height="35px" :src="file" alt="">
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div align="left">
                                <el-row style="margin-top: 9px">
                                    <!--<img width="35px"  height="40px" :src="file" alt="">-->
                                    <span style="margin-left: 10px">{{scope.row.quotation_name}}</span>

                                </el-row>
                            </div>
                        </el-col>
                        <el-col :span="15">
                            <div align="right">
                                <el-row style="margin-top: 9px">
                                    <span style="color: lightgray"> 有效日期：</span>
                                    <span style="color: dodgerblue">{{scope.row.effective_date}}</span>
                                    <span style="color: lightgray; margin-left: 10px"> 最新状态：</span>
                                    <span style="color: greenyellow">{{scope.row.statusStr}}</span>
                                    <span style="color: lightgray; margin-left: 10px"> |  总金额：</span>
                                    <span style="color: orange">{{scope.row.sumamount}}</span>
                                    <el-button type="warning" style="left: 10px" size="mini"
                                               @click.stop="showFifthInfo(scope.$index, scope.row)">
                                        详情

                                    </el-button>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>


                </template>
            </el-table-column>
        </el-table>


    </el-form>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {
//            form: {
//                type: Object,
//                default: () => {
//                }
//            },
//            obj: {
//                type: Object,
//                default: () => {
//                }
//
//            }
        },
        components: {},
        data() {
            return {
                form: {
                    tableData: [],
                },
                obj: {
//                    initiator: "RETAIL"
                    initiator: "SERVICE",
                    created_by: "",
                    account_name: "",
                    store_name: "",
                    alias: "",
                    ticket_id: '',
                    ticket_no: "",
                    phone: "",
                    photo: [],
                    status: "NEW",
                    stepDatas: [{title: "已接单"},
                        {title: "已派单"},
                        {title: "进行中"},
                        {title: "已完工"},
                        {title: "已评价"}],
                    reference_obj : ''
                },
            }
        },
        computed: {},
        created() {

        },
        methods: {
            getObj(data) {
                this.obj = data
            },
            setInfo(data) {
                this.form.tableData = data
            },
            addPrice(){
                this.$emit('addPrice')

            },
            showFifthInfo(index, row){
                this.$emit('showFifthInfo',row )
            },

        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/form/fifthForm.vue